import {
  sanitizeDOMString,
  sanitizeText,
  sanitizeTextForAnalytics,
} from "@/utils/helper"

export const getEventInfo = (pressReleaseInfo, type, linkName) => {
  const internalLinkName = linkName || type
  return JSON.stringify({
    eventAction: `press room:press releases:${type}`,
    eventName: `press room:press releases:${type}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName,
    internalLinkPosition: "press room",
    internalLinkType: `press room:${
      pressReleaseInfo["navTitle_s"]
        ? sanitizeText(pressReleaseInfo["navTitle_s"])
        : ""
    }`,
    internalLinkZoneName: "press room:press releases:main content area",
    internalLinkURL:
      linkName === "download" ? "n/a" : `${pressReleaseInfo["url_s"] ?? "#"}`,
    clickInternalLinks: "true",
  })
}

export const getTabContentEventInfo = (
  linkName,
  type,
  linkType,
  analyticsLabel,
  url = null,
  zone = null
) => {
  let zoneName
  switch (type) {
    case "email id":
      zoneName = linkType
      break
    case "share":
      zoneName = "contact"
      break
    default:
      zoneName = zone ?? "contacts"
  }

  let internalLinkURL
  switch (type) {
    case "contact number":
      internalLinkURL = `tel:${sanitizeDOMString(url).replace("\n", "")}`
      break
    default:
      internalLinkURL = "n/a"
  }

  return JSON.stringify({
    eventAction: `press room:${analyticsLabel}:${type}`,
    eventName: `press room:${analyticsLabel}:${type}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: sanitizeTextForAnalytics(linkName),
    internalLinkPosition: "press room",
    internalLinkType: `press room:${linkType}`,
    internalLinkZoneName: `press room:${analyticsLabel}:${zoneName}`,
    internalLinkURL,
    clickInternalLinks: "true",
  })
}

export const handleContactDataLayer = analyticsLabel => {
  return JSON.stringify({
    eventAction: `press room:${analyticsLabel}:print`,
    eventName: `press room:${analyticsLabel}:print`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "print",
    internalLinkPosition: "press room",
    internalLinkType: "press room:print",
    internalLinkZoneName: `press room:${analyticsLabel}:contacts`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  })
}

export const handleViewDataLayer = analyticsLabel => {
  return JSON.stringify({
    eventAction: `press room:p${analyticsLabel}:view more`,
    eventName: `press room:p${analyticsLabel}:view more`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "view more",
    internalLinkPosition: "press room",
    internalLinkType: "press room:view more",
    internalLinkZoneName: `press room:${analyticsLabel}:contacts`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  })
}
export const pressKitDataLayer = pressKitInfo => {
  return JSON.stringify({
    eventAction: "press room:press kits:view press kit link",
    eventName: "press room:press kits:view press kit link",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "view press kit",
    internalLinkPosition: "press room",
    internalLinkType: `press room:${pressKitInfo["navTitle_s"] || ""}`,
    internalLinkZoneName: "press room:press kits:main content area",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  })
}
export const getPressRoomEventInfo = (
  page,
  title,
  type,
  limit = "",
  all = ""
) => {
  page = page.replace("-", " ")
  return JSON.stringify({
    eventAction: `${title}:${page}:${type}`,
    eventName: `${title}:${page}:${type}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${limit || all}`,
    internalLinkPosition: `${page}`,
    internalLinkType: `${title}:${page}:${type}`,
    internalLinkZoneName: `${title}:${page}:main content area`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  })
}
